var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultAvatarIcon48Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f5f5f5;}.b{fill:none;stroke:#cccccd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-680 -336)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(680 336)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(679 335)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M38,40.6v-1.12a6,6,0,0,0-3.023-5.209l-5.971-3.425",
    transform: "translate(1.543 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19,30.847l-5.971,3.425A6,6,0,0,0,10,39.482V40.6",
    transform: "translate(0.457 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24,33h0c-4.418,0-8-4.582-8-9V20a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8v4C32,28.418,28.418,33,24,33Z",
    transform: "translate(1 0.87)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatarIcon48Px);
export default __webpack_public_path__ + "static/media/default-avatar-icon-48px.576e8d78fc3c2d3ae8bed6bd98c97254.svg";
export { ForwardRef as ReactComponent };